import ClassNames from '@streamloots/classnames';
import { PageFeed } from 'model/indexTS';
import { TranslateInterface } from 'utils/translation';
import Icon from 'ui-library/icons/Icons';
import { useMemo } from 'react';
import { PageFeedPermission } from '@streamloots/streamloots-types';
import { useFeedList } from './useFeedList';
import theme from './feed-list.scss';
import { ObfuscatedUnlockModalOpener } from './ObfuscatedUnlockModalOpener';

const classNames = ClassNames(theme);

export interface ObfuscatedFeedProps extends TranslateInterface {
  feed: PageFeed;
}

export const ObfuscatedFeed = ({ feed, t }: ObfuscatedFeedProps): JSX.Element => {
  const { page } = useFeedList();
  const title = useMemo(() => {
    if (feed.restrictedTo.includes(PageFeedPermission.PAID_CONTENT)) {
      return t('pageFeed:obfuscated.titlePay', { slug: page.slug });
    }

    if (!page.modules?.subscriptions.enabled) {
      return t('pageFeed:obfuscated.titleDisabledSubscription', { slug: page.slug });
    }

    return t('pageFeed:obfuscated.title', { slug: page.slug });
  }, [feed.restrictedTo, page, t]);

  return (
    <div className={classNames('feed-detail__offuscated')}>
      <div className={classNames('feed-detail__offuscated__content')}>
        <div className="align-center">
          <Icon id="lock" className={classNames('feed-detail__offuscated__content__icon')} />
          <div className={classNames('feed-detail__offuscated__content__title')}>{title}</div>
          <ObfuscatedUnlockModalOpener feed={feed} t={t} />
        </div>
      </div>
      {feed.summary.imageCount > 0 && (
        <div className={classNames('feed-detail__offuscated__summary')}>
          <Icon id="image" /> {t('pageFeed:obfuscated.summaryImage', { count: feed.summary.imageCount })}
        </div>
      )}
      {feed.summary.videoCount > 0 && (
        <div className={classNames('feed-detail__offuscated__summary')}>
          <Icon id="videocam_link" /> {t('pageFeed:obfuscated.summaryVideo', { count: feed.summary.videoCount })}
        </div>
      )}
    </div>
  );
};
